import OnlyHeader from "components/Layout/OnlyHeader";
import { Card, CardBody, CardHeader, Container, Row } from "reactstrap";
import Customize from "../components/Customization/Customize";

const Customization = () => {
  return (
    <>
      <OnlyHeader />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Card className="shadow">
          <CardHeader className="d-lg-flex d-sm-block justify-content-between">
            <Row className="pt-3 pb-0 px-2 px-md-4 ">
              <h3>Customization</h3>
            </Row>
          </CardHeader>
          <CardBody>
            <Customize />
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Customization;
